import cn from 'classnames';
import MessageOne from './message-one';
import ModelLoading from './model-loading';
import FinalAnswer from './final-answer';
import TaskerSheet from './tasker-sheet';

const ChatWindow = ({ className = '', step, setStep }) => (
  <div
    className={cn(
      'overflow-hidden border rounded-xl w-full border-neutral-800 relative aspect-[649/402]',
      className
    )}
  >
    <div className="grid grid-cols-2 p-2 md:grid-cols-3">
      <div className="flex space-x-2">
        <div className="w-3 h-3 bg-red-400 rounded-full" />
        <div className="w-3 h-3 rounded-full bg-utility-yellow" />
        <div className="w-3 h-3 rounded-full bg-utility-green" />
      </div>
      <div className="flex justify-end text-sm md:justify-center text-neutral-200">
        AI Text Generator
      </div>
      <div />
    </div>
    <div className={cn('h-full p-4 pb-4 space-y-2 text-xs bg-black text-neutral-200 relative')}>
      {step > 2 && <MessageOne isShowing={step > 2} setStep={setStep} step={step} />}
      <ModelLoading step={step} setStep={setStep} />
      <FinalAnswer isShowing={step === 9} setStep={setStep} />
    </div>

    <div className="absolute bottom-0 z-10 w-full">
      <TaskerSheet isShowing={step === 5 || step === 6} swapped={step === 6} setStep={setStep} />
    </div>
  </div>
);

export default ChatWindow;
